<div class="mt-auto flex justify-center p-6 pt-0 text-center dark:text-white-dark ltr:sm:text-left rtl:sm:text-right print:hidden">© {{ currYear }}. ZEPHYR {{ 'rights_reserved' | translate }}.</div>
